module.exports = __webpack_public_path__ + "img/faq.2e3fe0f3.svg";